import React from "react"

export default function BikroyIcon({ width = 20, height = 20 }) {
  const st0 = { fill: "#009877" }
  const st1 = { fill: "#FFFFFF" }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{ enableBackground: "new 0 0 1200 1200" }}
    >
      <g>
        <path
          style={st0}
          d="M815.13,200H384.87C282.77,200,200,282.77,200,384.87v430.37c0,102.1,82.77,184.87,184.87,184.87h430.26
          c102.1,0,184.87-82.77,184.87-184.87V384.87C1000,282.77,917.23,200,815.13,200z"
        />
        <path
          style={st1}
          d="M529.61,467.15c0,24.02-19.46,43.52-43.46,43.52c-24.02,0-43.49-19.5-43.49-43.52
          c0-23.99,19.46-43.46,43.49-43.46C510.15,423.69,529.61,443.16,529.61,467.15z"
        />
        <path
          style={st1}
          d="M757.9,467.15c0,24.02-19.46,43.52-43.49,43.52c-24.02,0-43.49-19.5-43.49-43.52
          c0-23.99,19.46-43.46,43.49-43.46C738.43,423.69,757.9,443.16,757.9,467.15z"
        />
        <path
          style={st1}
          d="M795.7,586.87H404.36c-11.14,0-20.19,8.4-21.51,19.17c0.17,2.81,0.4,5.49,0.6,8.3
          C393.03,729.37,486.25,815.19,600,815.19c113.71,0,207-85.79,216.55-200.79c0.23-2.81,0.43-5.62,0.6-8.46
          C815.79,595.23,806.77,586.87,795.7,586.87z"
        />
      </g>
    </svg>
  )
}
